import "./App.css";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import HomeTab from "./component/Pages/HomeTab";
import HomeMain from "./component/Pages/Home/HomeMain/HomeMain";
import Cateloging from "./component/Pages/Home/Cateloging/Cateloging";
import Crm from "./component/Pages/Home/CRM/Crm";
import Header from "./component/Pages/Home/HomeMain/Header/Header";
import Profile from "./component/Pages/Profile/Profile";
import Lead from "./component/Pages/Home/Lead/Lead";
import CrmDetailPage from "./component/Pages/Home/CrmDetail/CrmDetailPage";
import Ledger from "./component/Pages/Home/Ledger/Ledger";
import Oders from "./component/Pages/Orders/Oders";
import OdersDetail from "./component/Pages/Orders/OdersDetail/OdersDetail";
import { useEffect } from "react";
import Cookies from "js-cookie";
import { BrowserRouter } from "react-router-dom";
import CatelogingDetail from "./component/Pages/Home/CatelogingDetail/CatelogingDetail";
import CatelogingShare from "./component/Pages/Home/CatelogingShare/CatelogingShare";
import PrivacyPolicy from "./component/Pages/PrivacyPolicy/PrivacyPolicy ";
import SupportCenter from "./component/Pages/SupportCenter/SupportCenter";
import { useRecoilState } from "recoil";
import { homeLoading } from "./component/Recoil/atom";
import { CommonAPImain } from "./Utils/API/CommonAPImain/CommonAPImain";
import AccountDeleteStep from "./component/Pages/AccountDelete/AccountDeleteStep";
import Scanner from "./component/Pages/Scanner/Scanner";
import { ToastContainer } from "./component/Vuexy/Tostify/ToastManager";

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useRecoilState(homeLoading);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const device_token = queryParams.get("device_token");
    const token = queryParams.get("token");
    const SV = queryParams.get("SV");
    const redirectUrl = queryParams.get("redirectUrl");

    if (device_token !== undefined && SV !== null && token !== null) {
      sessionStorage.setItem("device_token", device_token);
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("SV", SV);
      sessionStorage.setItem("isLogin", true);

      Cookies.set("device_token", device_token);
      Cookies.set("token", token);
      Cookies.set("SV", SV);
    }

    if (redirectUrl) {
      navigate(redirectUrl);
    }
  }, [navigate]);

  const fetchData = async () => {
    try {
      const saleChartData = CommonAPImain("Home_SaleChart");
      const saleCategoryChartData = CommonAPImain("Home_CategorySale");
      const homeSale = CommonAPImain("Home_Sale");
      const homeOrder = CommonAPImain("Home_Order");
      const outStandingData = CommonAPImain("Home_Outstanding");
      const cateLogList = CommonAPImain("Catelog_List");
      const UserDetail = CommonAPImain("UserDetail");

      const responses = await Promise.all([
        saleChartData,
        saleCategoryChartData,
        homeSale,
        homeOrder,
        outStandingData,
        cateLogList,
        UserDetail,
      ]);

      if (responses[0]?.Status == 200) {
        sessionStorage.setItem(
          "saleDataChart",
          JSON.stringify(responses[0]?.Data)
        );
      }

      if (responses[1]?.Status == 200) {
        sessionStorage.setItem(
          "Home_CategorySale",
          JSON.stringify(responses[1]?.Data?.DT)
        );
      }

      if (responses[2]?.Status == 200) {
        sessionStorage.setItem(
          "Home_Sale",
          JSON.stringify(responses[2]?.Data?.DT[0])
        );
      }
      if (responses[3]?.Status == 200) {
        sessionStorage.setItem(
          "Home_Order",
          JSON.stringify(responses[3]?.Data?.DT[0])
        );
      }
      if (responses[4]?.Status == 200) {
        sessionStorage.setItem(
          "Home_Outstanding",
          JSON.stringify(responses[4]?.Data)
        );
      }

      if (responses[5]?.Status == 200) {
        const updatedData = responses[5]?.Data?.DT.map((item) => ({
          ...item,
          ImageToDisplay: item.AlbumImagePath || item.DefImage,
        }));
        sessionStorage.setItem("mainCatelogList", JSON.stringify(updatedData));
      }

      console.log('responsesresponses', responses);
      
      if (responses[6]?.Status == 200) {
        const profileData = responses[6]?.Data?.DT[0];
        const productPrintInfo = responses[6]?.Data?.DT1[0];
        sessionStorage.setItem("productPrintInfo", JSON.stringify(productPrintInfo));
        sessionStorage.setItem("profileData", JSON.stringify(profileData));
      }

      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const storedSaleData = sessionStorage.getItem("Home_Outstanding");
    const storedOrderData = sessionStorage.getItem("Home_Order");
    const storedOutStandingData = sessionStorage.getItem("Home_Sale");
    const storedFgStockData = sessionStorage.getItem("Home_CategorySale");
    const storedCart = sessionStorage.getItem("saleDataChart");
    if (
      storedCart ||
      storedSaleData ||
      storedOrderData ||
      storedOutStandingData ||
      storedFgStockData
    ) {
      setIsLoading(false);
    } else {
      fetchData();
    }

    const intervalId = setInterval(() => {
      fetchData();
    }, 3600000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const handleRefresh = () => {
    sessionStorage.removeItem("saleData");
    sessionStorage.removeItem("orderData");
    sessionStorage.removeItem("outStandingData");
    sessionStorage.removeItem("fgStockData");
    sessionStorage.clear();
    setIsLoading(true);
    fetchData();
  };

  return (
    <>
      <ToastContainer />
      {location.pathname === "/support" ||
      location.pathname === "/privacy-policy" ? (
        ""
      ) : (
        <Header handleRefresh={handleRefresh} />
      )}

      {location.pathname === "/Profile" ||
      location.pathname === "/CrmDetail" ||
      location.pathname === "/Oders" ||
      location.pathname === "/OdersDetail" ||
      location.pathname === "/CatelogingShare" ||
      location.pathname === "/CatelogingDetail" ||
      location.pathname === "/support" ||
      location.pathname === "/steps-account-delete" ||
      location.pathname === "/privacy-policy" ||
      location.pathname === "/NewCustomer" ||
      location.pathname === "/Ledger" ? (
        ""
      ) : (
        <HomeTab />
      )}
      <Routes>
        <Route path="/" element={<HomeMain />} />
        <Route path="/Cateloging" element={<Cateloging />} />
        <Route path="/CatelogingDetail" element={<CatelogingDetail />} />
        <Route path="/Crm" element={<Crm />} />
        <Route path="/CrmDetail" element={<CrmDetailPage />} />
        <Route path="/Lead" element={<Lead />} />
        <Route path="/Profile" element={<Profile />} />
        <Route path="/Ledger" element={<Ledger />} />
        <Route path="/OdersDetail" element={<OdersDetail />} />
        <Route path="/Oders" element={<Oders />} />
        <Route path="/CatelogingShare" element={<CatelogingShare />} />
        <Route path="/NewCustomer" element={<CatelogingShare />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/support" element={<SupportCenter />} />
        <Route path="/Scanner" element={<Scanner />} />
        <Route path="/steps-account-delete" element={<AccountDeleteStep />} />
      </Routes>
    </>
  );
}

export default App;
